'use client'

import type { ComponentType } from 'react'
import { Instagram, Facebook } from 'lucide-react'

type Props = {
  instagram?: string | null
  facebook?: string | null
  tiktok?: string | null
}

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M16.6 5.82a4.28 4.28 0 0 1-1.05-2.82h-3.07v12.3a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.78.12V9.7a5.66 5.66 0 1 0 4.88 5.6V9.01a7.3 7.3 0 0 0 4.2 1.33V7.27a4.28 4.28 0 0 1-3.15-1.45z" />
    </svg>
  )
}

/**
 * Enlaces a redes sociales del merchant (en el footer). Theme-aware vía
 * currentColor + tokens. Degrada — no renderiza — si no hay ninguna configurada.
 */
export function SocialLinks({ instagram, facebook, tiktok }: Props) {
  type Entry = { url: string; label: string; Icon: ComponentType<{ className?: string }> }
  const links = (
    [
      { url: instagram, label: 'Instagram', Icon: Instagram },
      { url: facebook, label: 'Facebook', Icon: Facebook },
      { url: tiktok, label: 'TikTok', Icon: TikTokIcon },
    ] as Array<{ url?: string | null; label: string; Icon: ComponentType<{ className?: string }> }>
  ).filter((l) => !!l.url && !!l.url.trim()) as Entry[]

  if (links.length === 0) return null

  return (
    <div className="flex items-center gap-2.5">
      {links.map(({ url, label, Icon }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="inline-flex items-center justify-center w-9 h-9 rounded-full transition hover:opacity-75"
          style={{ border: '1px solid var(--ms-border)', color: 'var(--ms-text-muted)' }}
        >
          <Icon className="w-[18px] h-[18px]" />
        </a>
      ))}
    </div>
  )
}
